import {
  AlovaDefaultCacheAdapter,
  AlovaGenerics,
  AlovaMethodCreateConfig,
  createAlova,
  RequestBody,
  StatesExport,
} from 'alova';
// @ts-ignore
import adapterFetch from 'alova/fetch';
import VueHook from 'alova/vue';
import { ElMessage } from 'element-plus';
import { getErrorMsg } from '@/service/errorMsg';
import { localMemory } from 'localmemory';
import { identityId } from '@/env';

const alovaInstance = createAlova({
  id: 'apiNoBaseURL',
  baseURL: '',

  cacheFor: {
    // 统一设置POST的缓存模式
    POST: {
      mode: 'memory',
      expire: 500,
    },
  },

  statesHook: VueHook,

  // 函数参数为一个method实例，包含如url、params、data、headers等请求数据
  // 你可以自由修改这些数据
  async beforeRequest(method) {
    method.config.headers.token = localMemory.getItem('userToken') || '';
    method.config.headers.lbeToken = localMemory.getItem('userToken') || '';;
    method.config.headers.lbeIdentity = identityId;
    if (!method.data) {
      method.data = {};
    }
  },

  requestAdapter: adapterFetch(),

  // 使用数组的两个项，分别指定请求成功的拦截器和请求失败的拦截器
  responded: {
    // 请求成功的拦截器
    // 当使用 `alova/fetch` 请求适配器时，第一个参数接收Response对象
    // 第二个参数为当前请求的method实例，你可以用它同步请求前后的配置信息
    onSuccess: async (response: any, method) => {
      console.log(response, 'response');

      const json = await response.json();
      if (json.code !== 0) {
        const msg = getErrorMsg(json.code);
        ElMessage.error($t(msg.msg));
        return Promise.reject(json);
      }

      // 解析的响应数据将传给method实例的transform钩子函数，这些函数将在后续讲解
      return json.data;
    },

    // 请求失败的拦截器
    // 请求错误时将会进入该拦截器。
    // 第二个参数为当前请求的method实例，你可以用它同步请求前后的配置信息
    onError: (err, method) => {
      if (!method.config['noTips']) {
        const msg = getErrorMsg(500);
        ElMessage.error($t(msg.msg));
      }
      return Promise.reject(err);
    },

    // 请求完成的拦截器
    // 当你需要在请求不论是成功、失败、还是命中缓存都需要执行的逻辑时，可以在创建alova实例时指定全局的`onComplete`拦截器，例如关闭请求 loading 状态。
    // 接收当前请求的method实例
    onComplete: async (method) => {
      // 处理请求完成逻辑
    },
  },
});

export const $http = alovaInstance;
